import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3006/consumer/order";
};

export const getMyRestaurantOrder = params => {
  return axios.post(`${baseURL()}`, params);
};

export const getMyRestaurantOrderDetails = id => {
  let url = `${baseURL()}/details/${id}`;
  return axios.get(url);
};

export const cancelMyOrderRestaurant = params => {
  let url = `${baseURL()}/CancelOrder`;
  return axios.post(url, params);
};

export const completeMyOrderRestaurant = params => {
  let url = `${baseURL()}/CompleteOrder`;
  return axios.post(url, params);
};
